import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Alert,
  Badge,
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
  Modal,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate, useLocation } from "react-router-dom";
import authApi from "../../api/authApi";
import jwt_decode from "jwt-decode";
import { isMobile } from "react-device-detect";
import helper from "../common/helper";
import { NameInitialsAvatar } from "react-name-initials-avatar";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import {
  FaBell,
  FaExclamationTriangle,
  FaInfoCircle,
  FaUserPlus,
  FaWhatsapp,
} from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import moment from "moment";
import IncomingCalls from "../calls/IncomingCalls";

const bgColors = [
  "#d3761f",
  "#00ad5b",
  "#debf31",
  "#239dd1",
  "#b67eb1",
  "#d3761f",
  "#de242f",
];
let notifColorIndex = 0;
const fillNotifBgColor = () => {
  notifColorIndex += 1;
  if (notifColorIndex >= bgColors.length) notifColorIndex = 0;
  return bgColors[notifColorIndex];
};

const Header = ({ socket, onWhatsAppSettingChange }) => {
  // 🔔 Notification sound
  const audioRef = useRef(null);
  const soundUnlockedRef = useRef(false);
  const unreadContactsMapRef = useRef({});

  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location);
  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  const showNewMessageToastRef = useRef(null);
  const handleNewLeadAssignmentRef = useRef(null);
  const playNotificationSoundRef = useRef(null);
  const fetchUnreadMessagesRef = useRef(async () => {});
  const [userInfo, setUserInfo] = useState({});
  const { tenantcode } = jwt_decode(sessionStorage.getItem("token"));
  const profileImage = `/public/${tenantcode}/users`;

  const [brokenImages, setBrokenImages] = useState([]);
  const [whatsappSetting, setWhatsappSetting] = useState([]);
  const [selectedSetting, setSelectedSetting] = useState(
    sessionStorage.getItem("selectedWhatsAppSetting") || "",
  );

  const activeSetting = whatsappSetting.find(
    (s) => String(s.phone) === String(selectedSetting),
  );

  const quality = activeSetting?.quality?.toLowerCase();
  const NOTIF_PAGE_SIZE = 10;

  // Notification bell state (list + total from POST /chat/conversations unread)
  const [showNotif, setShowNotif] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState([]);
  const [unreadBellTotal, setUnreadBellTotal] = useState(0);
  const [notifHasMore, setNotifHasMore] = useState(false);
  const [notifLoadingMore, setNotifLoadingMore] = useState(false);
  /** Next `offset` for getConversations (cursor; not list.length — avoids gaps if rows removed locally). */
  const notifFetchOffsetRef = useRef(0);
  const notifHasMoreRef = useRef(false);
  const notifLoadingMoreRef = useRef(false);
  const notifRef = useRef(null);

  // Toast notifications for new messages
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [toasts, setToasts] = useState([]); // Store multiple toasts

  const [showLeadNotif, setShowLeadNotif] = useState(false);
  const [leadNotifications, setLeadNotifications] = useState([]);
  const leadNotifRef = useRef(null);

  const [showCallUI, setShowCallUI] = useState(true);
  const [callEventReceived, setCallEventReceived] = useState(false);
  const [unreadContactsMap, setUnreadContactsMap] = useState({});

  const fetchData = useCallback(async () => {
    try {
      const response = await WhatsAppAPI.getWhatsAppSettingRecord();
      if (response.success) {
        const selectedWhatsAppSetting = sessionStorage.getItem(
          "selectedWhatsAppSetting",
        );
        const initialSetting = response.record.find(
          (record) => record.phone === selectedWhatsAppSetting,
        )
          ? selectedWhatsAppSetting
          : (() => {
              const newPhone = response.record[0]?.phone;
              sessionStorage.setItem("selectedWhatsAppSetting", newPhone);
              return newPhone;
            })();

        onWhatsAppSettingChange?.(initialSetting);
        setSelectedSetting(initialSetting);
        setWhatsappSetting(response.record);
      } else {
        setWhatsappSetting([]);
      }
    } catch (error) {
      setWhatsappSetting([]);
    }
  }, [onWhatsAppSettingChange]);

  /** True after user hid the tab/window; used to refetch settings once when they come back (avoids duplicate API calls on load). */
  const tabWasHiddenRef = useRef(false);

  const getHeaderStyle = () => {
    if (quality === "red" || quality === "low") {
      return {
        backgroundColor: "#ffe5e5",
        borderBottom: "2px solid #dc3545",
      };
    }

    if (quality === "yellow" || quality === "medium") {
      return {
        backgroundColor: "#fff4e5",
        borderBottom: "2px solid #ffc107",
      };
    }

    return {}; // default
  };
  const renderQualityWarning = () => {
    if (quality === "red" || quality === "low") {
      return (
        <Alert
          variant="danger"
          className="header-quality-banner mb-0 rounded-0 border-0 py-2 py-md-3 px-3 px-lg-4 d-flex align-items-start gap-3"
          style={{
            borderBottom: "1px solid rgba(185, 28, 28, 0.35)",
            boxShadow: "inset 0 1px 0 rgba(255,255,255,0.12)",
            background:
              "linear-gradient(135deg, rgba(220, 53, 69, 0.14) 0%, rgba(114, 28, 36, 0.08) 100%)",
          }}
        >
          <span
            className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center text-danger bg-danger bg-opacity-10"
            style={{ width: 42, height: 42 }}
            aria-hidden
          >
            <FaExclamationTriangle size={20} />
          </span>
          <div className="flex-grow-1 min-w-0 pt-0">
            <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
              <span className="fw-semibold text-danger-emphasis">
                WhatsApp quality rating: Low
              </span>
              <Badge bg="danger" pill className="fw-normal">
                High risk
              </Badge>
            </div>
            <p className="mb-0 small text-body lh-sm">
              We have stopped your campaigns because your WhatsApp quality
              rating is low. Campaigns will start again automatically when your
              quality is high again. Meta may still limit your number until
              then.
            </p>
          </div>
        </Alert>
      );
    }

    if (quality === "yellow" || quality === "medium") {
      return (
        <Alert
          variant="warning"
          className="header-quality-banner mb-0 rounded-0 border-0 py-2 py-md-3 px-3 px-lg-4 d-flex align-items-start gap-3"
          style={{
            borderBottom: "1px solid rgba(217, 119, 6, 0.35)",
            boxShadow: "inset 0 1px 0 rgba(255,255,255,0.25)",
            background:
              "linear-gradient(135deg, rgba(255, 193, 7, 0.18) 0%, rgba(253, 230, 138, 0.35) 100%)",
          }}
        >
          <span
            className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center text-warning-emphasis bg-warning bg-opacity-25"
            style={{ width: 42, height: 42 }}
            aria-hidden
          >
            <FaInfoCircle size={20} />
          </span>
          <div className="flex-grow-1 min-w-0 pt-0">
            <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
              <span className="fw-semibold text-dark-emphasis">
                WhatsApp quality rating: Medium
              </span>
              <Badge bg="warning" text="dark" pill className="fw-normal">
                Monitor closely
              </Badge>
            </div>
            <p className="mb-0 small text-dark lh-sm">
              Send only to engaged contacts and avoid spam-like messaging so
              your rating can return to high.
            </p>
          </div>
        </Alert>
      );
    }

    return null;
  };
  const unlockNotificationSound = () => {
    if (soundUnlockedRef.current) return;

    try {
      if (!audioRef.current) {
        audioRef.current = new Audio("/ringtone.wav");
        audioRef.current.volume = 0.3;
      }

      audioRef.current
        .play()
        .then(() => {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          soundUnlockedRef.current = true;
        })
        .catch(() => {});
    } catch (e) {}
  };

  useEffect(() => {
    const unlock = () => {
      unlockNotificationSound();
      window.removeEventListener("click", unlock);
      window.removeEventListener("keydown", unlock);
    };

    window.addEventListener("click", unlock);
    window.addEventListener("keydown", unlock);

    return () => {
      window.removeEventListener("click", unlock);
      window.removeEventListener("keydown", unlock);
    };
  }, []);

  useEffect(() => {
    if (!sessionStorage.getItem("token")) navigate("/login");
    try {
      setUserInfo(jwt_decode(sessionStorage.getItem("token")));
    } catch (error) {
      // ignore
    }
  }, [navigate]);

  // One request per route change (covers initial load + SPA navigation). Quality updates after Meta sync when user returns to tab: see below.
  useEffect(() => {
    fetchData();
  }, [location.pathname, fetchData]);

  // Refetch only when the tab becomes visible again after being hidden (no extra calls on first paint or duplicate focus + visibility).
  useEffect(() => {
    const onVisibility = () => {
      if (document.visibilityState === "hidden") {
        tabWasHiddenRef.current = true;
        return;
      }
      if (
        document.visibilityState === "visible" &&
        tabWasHiddenRef.current
      ) {
        tabWasHiddenRef.current = false;
        fetchData();
      }
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () =>
      document.removeEventListener("visibilitychange", onVisibility);
  }, [fetchData]);

  /** Load bell unread count once WhatsApp business line is known (same API as messenger unread tab). */
  useEffect(() => {
    if (selectedSetting) {
      fetchUnreadMessagesRef.current?.();
    }
  }, [selectedSetting]);

  // Function to show new message toast notification
  const showNewMessageToast = (messageData) => {
    // Format the phone number for display
    const formatNumberForToast = (number) => {
      const shouldHideNumber =
        userInfo?.userrole === "USER" &&
        userInfo?.is_whatsapp_number_hidden === true;

      if (shouldHideNumber && number) {
        const numberString = String(number);
        if (numberString.length <= 5) return numberString;
        const visibleDigits = numberString.slice(-5);
        const maskedDigits = "X".repeat(numberString.length - 5);
        return `${maskedDigits}${visibleDigits}`;
      }
      return number;
    };

    // Extract and format the from number
    const fromNumber = messageData.from || "";
    let displayNumber = fromNumber;

    if (fromNumber) {
      // Remove + sign if present
      const cleanNumber = fromNumber.replace("+", "");

      // Format for display
      if (cleanNumber.length > 10) {
        // Remove country code for display
        displayNumber = cleanNumber.substring(2);
      } else {
        displayNumber = cleanNumber;
      }

      // Apply masking if needed
      displayNumber = formatNumberForToast(displayNumber);
    }

    const formattedMessage = {
      id: Date.now(),
      from: messageData.from,
      contactName: messageData.contact_name || displayNumber,
      originalContactName: messageData.contact_name,
      displayNumber: displayNumber,
      message: messageData.text?.body || "New message",
      timestamp: messageData.timestamp
        ? new Date(parseInt(messageData.timestamp) * 1000)
        : new Date(),
      messageId: messageData.id,
    };

    // console.log("New message toast:", formattedMessage);

    // Add new toast to the array
    setToasts((prev) => [formattedMessage, ...prev].slice(0, 3));

    // Auto-remove toast after 5 seconds
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== formattedMessage.id));
    }, 5000);
  };
  // Handle click on toast notification
  const handleToastClick = (toastData) => {
    // Remove the toast
    setToasts((prev) => prev.filter((t) => t.id !== toastData.id));

    // Mark messages as read using full_number
    WhatsAppAPI.markMessagesAsRead(toastData.from, selectedSetting);

    // Navigate to whatsapp_messenger
    navigate("/whatsapp_messenger", {
      state: {
        fromNotification: true,
        phoneNumber: toastData.from,
        messageId: toastData.messageId,
        autoOpenChat: true,
      },
    });
  };

  const formatPhoneNumber = (number) => {
    const shouldHideNumber =
      userInfo?.userrole === "USER" &&
      userInfo?.is_whatsapp_number_hidden === true;

    if (shouldHideNumber && number) {
      const numberString = String(number);
      if (numberString.length <= 5) return numberString;
      const visibleDigits = numberString.slice(-5);
      const maskedDigits = "X".repeat(numberString.length - 5);
      return `${maskedDigits}${visibleDigits}`;
    }
    return number;
  };

  const handleNewLeadAssignment = (data) => {
    const newNotification = {
      id: Date.now() + Math.random(),
      type: "lead",
      message: data.message,
      lead: {
        ...data.lead,
        display_whatsapp_number: formatPhoneNumber(data.lead.whatsapp_number),
      },
      assignedBy: data.assignedBy,
      timestamp: data.timestamp || new Date(),
      read: false,
    };

    setLeadNotifications((prev) => {
      const filtered = prev.filter(
        (notif) => notif.lead.whatsapp_number !== data.lead.whatsapp_number,
      );
      const updated = [...filtered, newNotification].sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp),
      );
      return updated.slice(0, 50);
    });

    // Browser notification
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        new Notification("New Lead Assigned", {
          body: data.message,
          icon: "/lead-icon.png",
          tag: "lead-assignment",
        });
      } else if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            new Notification("New Lead Assigned", {
              body: data.message,
              icon: "/lead-icon.png",
              tag: "lead-assignment",
            });
          }
        });
      }
    }

    playNotificationSound();
  };

  const playNotificationSound = () => {
    if (!soundUnlockedRef.current || !audioRef.current) {
      // console.log("⚠️ Sound not unlocked yet");
      return;
    }

    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(() => {});
  };

  // Mark lead notification as read
  const markLeadNotificationAsRead = async (notificationId, leadId) => {
    setLeadNotifications((prev) =>
      prev.map((notif) =>
        notif.id === notificationId ? { ...notif, read: true } : notif,
      ),
    );
  };

  // Mark all lead notifications as read
  const markAllLeadNotificationsAsRead = async () => {
    setLeadNotifications((prev) =>
      prev.map((notif) => ({ ...notif, read: true })),
    );
    try {
      await WhatsAppAPI.deleteAllAssignedLeads();
    } catch (e) {
      // console.log("Failed to delete all assigned leads:", e);
    }
  };

  // Get unread lead notifications count
  const getUnreadLeadNotificationsCount = () => {
    return leadNotifications.filter((notif) => !notif.read).length;
  };

  // Navigate to lead details
  const navigateToLead = (leadId) => {
    setShowLeadNotif(false);
    navigate(`/leads/${leadId}`);
  };

  const handleSettingChange = (e) => {
    const selectedId = e.target.value;
    setSelectedSetting(selectedId);
    sessionStorage.setItem("selectedWhatsAppSetting", selectedId);
    if (onWhatsAppSettingChange) {
      onWhatsAppSettingChange(selectedId);
    }
    if (socket) {
      socket.emit("business_number_changed", {
        deviceId: localStorage.getItem("deviceId"),
        business_number: selectedId,
      });
    }
    fetchUnreadMessagesRef.current?.(selectedId);
  };

  const logout = () => {
    authApi.logout();
    navigate("/login");
  };

  const toggleSidebar = () => {
    document.querySelector("#sidebar").classList.toggle("hide");
    document.querySelector("#sidebar").classList.toggle("show");
  };

  const mapConversationRowToNotification = (row) => {
    const fullNum = row.full_number
      ? String(row.full_number).startsWith("+")
        ? String(row.full_number)
        : `+${String(row.full_number).replace(/^\+/, "")}`
      : "";
    const phoneWithoutPlus = fullNum.replace(/^\+/, "") || "";
    const phoneForDisplay =
      phoneWithoutPlus.length > 10
        ? phoneWithoutPlus.slice(-10)
        : phoneWithoutPlus;
    const leadId = row.lead_id || row.id;

    return {
      id: leadId,
      lead_id: row.lead_id,
      whatsapp_number: phoneForDisplay,
      full_number: fullNum || row.full_number,
      display_whatsapp_number: formatPhoneNumber(phoneForDisplay),
      display_full_number: formatPhoneNumber(phoneWithoutPlus),
      unread_msg_count: parseInt(row.unread_count, 10) || 0,
      name: row.contactname,
      contactname: row.contactname,
      message_createddate: row.last_message_time,
      createddate: row.last_message_time,
      country_code: row.countrycode,
      message: row.message,
    };
  };

  const mergeIntoUnreadMap = (prevMap, contacts) => {
    const next = { ...prevMap };
    contacts.forEach((contact) => {
      if (contact.full_number) {
        next[contact.full_number] = contact;
        next[contact.full_number.replace("+", "")] = contact;
      }
    });
    return next;
  };

  /** Unread bell: POST /chat/conversations `recordType: "unread"`. Pass `{ append: true }` to load next page. */
  const fetchUnreadMessages = async (businessNumberOverride, opts = {}) => {
    const append = opts.append === true;
    const businessNumber = businessNumberOverride ?? selectedSetting;
    if (!businessNumber) return;

    if (append) {
      if (notifLoadingMoreRef.current || !notifHasMoreRef.current) return;
      notifLoadingMoreRef.current = true;
      setNotifLoadingMore(true);
    } else {
      notifFetchOffsetRef.current = 0;
    }

    const offset = append ? notifFetchOffsetRef.current : 0;

    try {
      const res = await WhatsAppAPI.getConversations({
        textName: "",
        recordType: "unread",
        limit: NOTIF_PAGE_SIZE,
        offset,
        tagFilterLogic: "OR",
        business_number: businessNumber,
      });

      if (
        res?.success &&
        Array.isArray(res.records) &&
        res.records.length > 0
      ) {
        const mapped = res.records.map(mapConversationRowToNotification);
        const contactsWithUnread = mapped.filter((m) => m.unread_msg_count > 0);

        notifFetchOffsetRef.current += res.records.length;

        if (append) {
          setUnreadMessages((prev) => {
            const seen = new Set(prev.map((p) => String(p.id)));
            const merged = [...prev];
            for (const row of contactsWithUnread) {
              const key = String(row.id);
              if (!seen.has(key)) {
                seen.add(key);
                merged.push(row);
              }
            }
            return merged;
          });
          setUnreadContactsMap((prev) => {
            const next = mergeIntoUnreadMap(prev, contactsWithUnread);
            unreadContactsMapRef.current = next;
            return next;
          });
        } else {
          const unreadMap = {};
          contactsWithUnread.forEach((contact) => {
            if (contact.full_number) {
              unreadMap[contact.full_number] = contact;
              unreadMap[contact.full_number.replace("+", "")] = contact;
            }
          });
          setUnreadContactsMap(unreadMap);
          unreadContactsMapRef.current = unreadMap;
          setUnreadMessages(contactsWithUnread);
          setUnreadBellTotal(
            typeof res.total === "number"
              ? res.total
              : contactsWithUnread.length,
          );
        }

        const hasMore =
          res.hasMore === true ||
          (typeof res.total === "number" &&
            notifFetchOffsetRef.current < res.total);
        notifHasMoreRef.current = hasMore;
        setNotifHasMore(hasMore);
      } else {
        if (!append) {
          setUnreadContactsMap({});
          unreadContactsMapRef.current = {};
          setUnreadMessages([]);
          setUnreadBellTotal(0);
        }
        notifHasMoreRef.current = false;
        setNotifHasMore(false);
      }
    } catch (e) {
      console.error("Error fetching unread messages:", e);
      if (!append) {
        setUnreadContactsMap({});
        unreadContactsMapRef.current = {};
        setUnreadMessages([]);
        setUnreadBellTotal(0);
      }
      notifHasMoreRef.current = false;
      setNotifHasMore(false);
    } finally {
      notifLoadingMoreRef.current = false;
      setNotifLoadingMore(false);
    }
  };

  const handleNotifListScroll = (e) => {
    const el = e.currentTarget;
    if (notifLoadingMoreRef.current || !notifHasMoreRef.current) return;
    const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 72;
    if (nearBottom) {
      fetchUnreadMessages(undefined, { append: true });
    }
  };

  useEffect(() => {
    if (!socket) return undefined;

    const onConnect = () => {
      fetchUnreadMessagesRef.current?.();
    };

    const onReceivedWhatsappMessage = (data) => {
      const isIncomingMessage = data?.from && data?.type && !data?.status;

      if (isIncomingMessage) {
        const fromNumber = data.from || "";
        const numberWithoutPlus = fromNumber.replace("+", "");

        const currentMap = unreadContactsMapRef.current;

        const isUnreadContact =
          currentMap[fromNumber] || currentMap[numberWithoutPlus];

        if (isUnreadContact) {
          playNotificationSoundRef.current?.();
          showNewMessageToastRef.current?.(data);

          const p = locationRef.current?.pathname;
          const onHome = p === "/" || p === "/home" || p === "/app";
          if (onHome) {
            setTimeout(() => {
              navigate("/whatsapp_messenger", {
                state: {
                  fromNotification: true,
                  phoneNumber: data.from,
                  messageId: data.id,
                },
              });
            }, 2000);
          }
        }
      }

      // Refresh bell only for inbound-style payloads that include a sender (`from`), e.g. user messages — not status-only events.
      if (data?.from) {
        fetchUnreadMessagesRef.current?.();
      }
    };

    const onMessagesMarkedAsRead = () => {
      fetchUnreadMessagesRef.current?.();
    };

    const onLeadAssigned = (data) => {
      playNotificationSoundRef.current?.();
      handleNewLeadAssignmentRef.current?.(data);
    };

    socket.on("connect", onConnect);
    socket.on("receivedwhatsappmessage", onReceivedWhatsappMessage);
    socket.on("messagesmarkedasread", onMessagesMarkedAsRead);
    socket.on("new-lead-assigned", onLeadAssigned);
    socket.on("lead-reassigned", onLeadAssigned);

    return () => {
      socket.off("connect", onConnect);
      socket.off("receivedwhatsappmessage", onReceivedWhatsappMessage);
      socket.off("messagesmarkedasread", onMessagesMarkedAsRead);
      socket.off("new-lead-assigned", onLeadAssigned);
      socket.off("lead-reassigned", onLeadAssigned);
    };
  }, [socket, navigate]);

  // Mark messages as read for a contact
  const markContactMessagesAsRead = async (contact) => {
    try {
      // Use full_number if available, otherwise use whatsapp_number with country_code
      const phoneNumber =
        contact.full_number ||
        (contact.country_code && contact.whatsapp_number
          ? `${contact.country_code}${contact.whatsapp_number}`
          : contact.whatsapp_number);

      await WhatsAppAPI.markMessagesAsRead(phoneNumber, selectedSetting);

      // Remove from unread list
      setUnreadMessages((prev) => prev.filter((m) => m.id !== contact.id));
      setUnreadBellTotal((n) => Math.max(0, n - 1));

      // Update both state and ref
      setUnreadContactsMap((prev) => {
        const newMap = { ...prev };
        delete newMap[phoneNumber];
        delete newMap[phoneNumber.replace("+", "")];

        // Also update the ref
        unreadContactsMapRef.current = newMap;

        return newMap;
      });

      return true;
    } catch (error) {
      console.error("Error marking messages as read:", error);
      return false;
    }
  };

  const markAllMessagesAsRead = async () => {
    try {
      await WhatsAppAPI.markMessagesAsRead(null, selectedSetting);
      setUnreadMessages([]);
      setUnreadBellTotal(0);
      notifFetchOffsetRef.current = 0;
      notifHasMoreRef.current = false;
      setNotifHasMore(false);
      setUnreadContactsMap({});
      unreadContactsMapRef.current = {}; // Clear the ref

      return true;
    } catch (error) {
      console.error("Error marking all messages as read:", error);
      return false;
    }
  };

  showNewMessageToastRef.current = showNewMessageToast;
  handleNewLeadAssignmentRef.current = handleNewLeadAssignment;
  playNotificationSoundRef.current = playNotificationSound;
  fetchUnreadMessagesRef.current = fetchUnreadMessages;

  const qualityBannerEl = renderQualityWarning();

  return (
    <>
      {/* Toast Notifications Container */}
      <ToastContainer
        className="p-3"
        position="top-end"
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 9999,
        }}
      >
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            onClose={() =>
              setToasts((prev) => prev.filter((t) => t.id !== toast.id))
            }
            show={true}
            delay={5000}
            autohide
            bg="success"
            className="mb-2"
            style={{
              minWidth: "300px",
              maxWidth: "350px",
              border: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
            onClick={() => handleToastClick(toast)}
          >
            <Toast.Header closeButton={false}>
              <FaWhatsapp className="me-2" />
              <strong className="me-auto">New WhatsApp Message</strong>
              <small className="text-muted">
                {moment(toast.timestamp).fromNow()}
              </small>
            </Toast.Header>
            <Toast.Body className="text-white">
              <div className="d-flex align-items-start">
                <div className="flex-grow-1">
                  <strong className="d-block">{toast.contactName}</strong>
                  <p className="mb-0 mt-1" style={{ fontSize: "0.9rem" }}>
                    {toast.message.length > 50
                      ? `${toast.message.substring(0, 50)}...`
                      : toast.message}
                  </p>
                </div>
                <Button
                  variant="link"
                  className="p-0 text-white ms-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    setToasts((prev) => prev.filter((t) => t.id !== toast.id));
                  }}
                >
                  <i className="fas fa-times"></i>
                </Button>
              </div>
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>

      <Navbar
        className="header navbar-app-bar px-2"
        bg=""
        expand="lg"
        variant=""
        style={{ marginBottom: isMobile ? "1rem" : "0" }}
      >
        <button
          type="button"
          id="sidebarCollapse"
          className="btn header-menu-toggle"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          <i className="fas fa-align-left" />
        </button>
        <Navbar.Brand href="#home" className="d-none d-md-block m-0 p-0" />
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="header-mobile-toggle border-0 shadow-none"
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto align-items-center flex-grow-1 min-w-0 py-1 py-lg-0">
            {/* <NavLink
              to="/myprofile"
              className="p-0 d-flex align-items-center"
              style={{ fontSize: ".9rem", textDecoration: "none" }}
            >
              {brokenImages.includes(`img-${userInfo.id}`) ? (
                <NameInitialsAvatar
                  size="30px"
                  textSize="12px"
                  bgColor="#49C858"
                  borderWidth="0px"
                  textColor="#fff"
                  name={userInfo.username}
                />
              ) : (
                <img
                  alt=""
                  style={{ height: "30px", width: "30px" }}
                  src={profileImage + "/" + userInfo.id}
                  className="rounded-circle"
                  onError={() =>
                    setBrokenImages((prev) => [...prev, `img-${userInfo.id}`])
                  }
                  id={`img-${userInfo.id}`}
                />
              )}
              <Badge
                style={{ fontSize: ".9rem" }}
                bg="light"
                text="dark"
                className="mx-2"
              >
                {userInfo.username}
              </Badge>
              <Badge bg="success" style={{ fontSize: ".9rem" }}>
                {userInfo.userrole}
              </Badge>
            </NavLink> */}

            <div className="d-flex align-items-center gap-1 gap-sm-2 ms-0 ms-sm-1 min-w-0 flex-nowrap">
              <span
                className="header-brand-mark d-none d-sm-inline-flex"
                aria-hidden
                onClick={() => navigate("/whatsapp_messenger")}
              >
                <FaWhatsapp size={18} />
              </span>
              <span
                className="header-company-pill text-truncate"
                title={userInfo.companyname || ""}
              >
                {userInfo.companyname || "—"}
              </span>
            </div>
          </Nav>
          <Nav className="ms-auto d-flex align-items-center flex-nowrap gap-2 py-1 flex-shrink-0">
            {userInfo?.modules?.some((module) => module.url === "calls") && (
              <>
                {callEventReceived && (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        {showCallUI ? "Hide Call UI" : "Show Call UI"}
                      </Tooltip>
                    }
                  >
                    <Button
                      variant={showCallUI ? "danger" : "success"}
                      onClick={() => setShowCallUI((prev) => !prev)}
                      className="flex-shrink-0"
                      title={showCallUI ? "Hide Call Panel" : "Show Call Panel"}
                      style={{
                        borderRadius: "50%",
                        width: 45,
                        height: 30,
                        padding: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FaPhoneAlt size={12} />
                    </Button>
                  </OverlayTrigger>
                )}

                <IncomingCalls
                  socket={socket}
                  selectedBusinessNumber={selectedSetting}
                  showCallUI={showCallUI}
                  setCallEventReceived={setCallEventReceived}
                />
              </>
            )}

            <div className="header-quick-actions d-flex align-items-center flex-nowrap gap-2 flex-shrink-0">
              {userInfo.userrole === "USER" && (
                <div className="header-icon-slot position-relative flex-shrink-0">
                  <span ref={leadNotifRef}>
                    <FaUserPlus
                      size={18}
                      className="header-toolbar-icon-inner"
                      style={{
                        cursor: "pointer",
                        color:
                          getUnreadLeadNotificationsCount() > 0
                            ? "#ea580c"
                            : "var(--text-color-2)",
                      }}
                      onClick={() => setShowLeadNotif(!showLeadNotif)}
                      title="Lead Assignments"
                    />
                  </span>
                  {getUnreadLeadNotificationsCount() > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: -4,
                        right: -4,
                        background: "#ff6b35",
                        color: "white",
                        borderRadius: "50%",
                        fontSize: 10,
                        minWidth: 18,
                        height: 18,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 2,
                      }}
                    >
                      {getUnreadLeadNotificationsCount()}
                    </span>
                  )}
                  <Overlay
                    show={showLeadNotif}
                    target={leadNotifRef.current}
                    placement="bottom"
                    containerPadding={20}
                    rootClose
                    onHide={() => setShowLeadNotif(false)}
                  >
                    <Popover
                      id="lead-notif-popover"
                      style={{ minWidth: 350, maxWidth: 400 }}
                    >
                      <Popover.Header
                        as="h6"
                        className="d-flex justify-content-between align-items-center"
                      >
                        <span>Lead Assignments</span>
                        {leadNotifications.length > 0 && (
                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 text-primary text-decoration-none"
                            onClick={markAllLeadNotificationsAsRead}
                          >
                            Mark all read
                          </Button>
                        )}
                      </Popover.Header>
                      <Popover.Body className="p-0">
                        <div style={{ maxHeight: 300, overflowY: "auto" }}>
                          {leadNotifications.length === 0 ? (
                            <div className="text-center py-4 text-muted">
                              No lead assignments
                            </div>
                          ) : (
                            leadNotifications.map((notif) => {
                              const timeAgo = moment(notif.timestamp).fromNow();
                              return (
                                <div
                                  key={notif.id}
                                  className={`d-flex align-items-start py-3 px-3 border-bottom ${
                                    !notif.read ? "bg-light" : ""
                                  }`}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    markLeadNotificationAsRead(
                                      notif.id,
                                      notif.lead.id,
                                    );
                                    navigateToLead(notif.lead.id);
                                    setShowLeadNotif(false);
                                  }}
                                >
                                  <div className="me-3 mt-1">
                                    <NameInitialsAvatar
                                      name={
                                        notif.lead.firstname +
                                        " " +
                                        notif.lead.lastname
                                      }
                                      size="35px"
                                      textSize="12px"
                                      bgColor={fillNotifBgColor()}
                                      borderWidth="0px"
                                      textColor="#fff"
                                    />
                                  </div>
                                  <div className="flex-grow-1">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <b className="d-block">
                                          {notif.lead.firstname}{" "}
                                          {notif.lead.lastname}
                                        </b>
                                        <small className="text-muted">
                                          {notif.lead.country_code}{" "}
                                          {notif.lead.display_whatsapp_number ||
                                            formatPhoneNumber(
                                              notif.lead.whatsapp_number,
                                            )}
                                        </small>
                                      </div>
                                      {!notif.read && (
                                        <span
                                          className="badge bg-primary"
                                          style={{ fontSize: 9 }}
                                        >
                                          NEW
                                        </span>
                                      )}
                                    </div>
                                    <div
                                      className="text-muted mt-1"
                                      style={{ fontSize: "0.8rem" }}
                                    >
                                      {notif.message}
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                      <small className="text-muted">
                                        By: {notif.assignedBy?.name || "System"}
                                      </small>
                                      <small className="text-muted">
                                        {timeAgo}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </div>
              )}
              {/* Bell + setting + logout stay on one row */}
              <div className="header-icon-slot position-relative flex-shrink-0">
                <span ref={notifRef}>
                  <FaBell
                    size={18}
                    className="header-toolbar-icon-inner"
                    style={{
                      cursor: "pointer",
                      color: "var(--theme-color-2)",
                    }}
                    onClick={() => setShowNotif(!showNotif)}
                    title="Unread messages"
                  />
                </span>
                {unreadBellTotal > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: -4,
                      right: -4,
                      background: "red",
                      color: "white",
                      borderRadius: "50%",
                      fontSize: 12,
                      padding: "2px 6px",
                      zIndex: 2,
                      minWidth: 20,
                      textAlign: "center",
                    }}
                  >
                    {unreadBellTotal > 99 ? "99+" : unreadBellTotal}
                  </span>
                )}
                <Overlay
                  show={showNotif}
                  target={notifRef.current}
                  placement="bottom"
                  containerPadding={20}
                  rootClose
                  onHide={() => setShowNotif(false)}
                >
                  <Popover
                    id="unread-popover"
                    style={{ minWidth: 350, maxWidth: 400 }}
                  >
                    <Popover.Header
                      as="h6"
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span>Unread Messages</span>
                      <div>
                        <Button
                          variant="link"
                          size="sm"
                          className="p-0 me-2"
                          onClick={fetchUnreadMessages}
                          title="Refresh"
                        >
                          <i className="fas fa-sync-alt"></i>
                        </Button>
                        {unreadMessages.length > 0 && (
                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 text-primary text-decoration-none"
                            onClick={async () => {
                              await markAllMessagesAsRead();
                            }}
                          >
                            Mark all read
                          </Button>
                        )}
                      </div>
                    </Popover.Header>
                    <Popover.Body className="p-0">
                      <div
                        style={{ maxHeight: 320, overflowY: "auto" }}
                        onScroll={handleNotifListScroll}
                      >
                        {unreadMessages.length === 0 ? (
                          <div className="text-center py-4">
                            No unread messages
                          </div>
                        ) : (
                          unreadMessages.map((msg, idx) => {
                            const created = moment(
                              msg.message_createddate || msg.createddate,
                            );
                            return (
                              <div
                                key={msg.id || msg.whatsapp_number}
                                className="d-flex align-items-center py-3 px-3 border-bottom"
                                style={{ cursor: "pointer" }}
                                onClick={async () => {
                                  // Mark messages as read using full_number
                                  await markContactMessagesAsRead(msg);

                                  // Redirect to leads page with lead id
                                  const leadNavId = msg.lead_id || msg.id;
                                  if (leadNavId) {
                                    navigate(`/leads/${leadNavId}`, {
                                      state: {
                                        leadName: msg.name || msg.contactname,
                                        leadPhone:
                                          msg.full_number ||
                                          msg.whatsapp_number,
                                        fromNotification: true,
                                        unreadMessages: msg.unread_msg_count,
                                      },
                                    });
                                  } else {
                                    navigate("/whatsapp_messenger", {
                                      state: {
                                        searchPhone:
                                          msg.full_number ||
                                          msg.whatsapp_number,
                                        contactName:
                                          msg.name || msg.contactname,
                                        fromNotification: true,
                                        autoOpenChat: true,
                                      },
                                    });
                                  }

                                  // Close the notification popover
                                  setShowNotif(false);
                                }}
                              >
                                <div className="me-3">
                                  <NameInitialsAvatar
                                    name={
                                      msg.name ||
                                      msg.contactname ||
                                      msg.whatsapp_number
                                    }
                                    size="30px"
                                    textSize="13px"
                                    bgColor={bgColors[idx % bgColors.length]}
                                    borderWidth="0px"
                                    textColor="#fff"
                                  />
                                </div>
                                <div className="flex-grow-1">
                                  <div>
                                    <b>
                                      {msg.name ||
                                        msg.contactname ||
                                        msg.display_whatsapp_number ||
                                        formatPhoneNumber(msg.whatsapp_number)}
                                    </b>
                                    <Badge
                                      bg="success"
                                      pill
                                      className="ms-2"
                                      style={{ fontSize: 10 }}
                                    >
                                      {msg.unread_msg_count}
                                    </Badge>
                                  </div>
                                  <small className="text-muted">
                                    {msg.display_full_number ||
                                      msg.full_number ||
                                      `${msg.country_code}${msg.whatsapp_number}`}
                                  </small>
                                  <div>
                                    <small className="text-muted">
                                      Last message:{" "}
                                      {created.format("D MMM YYYY, h:mm a")}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                        {notifLoadingMore && (
                          <div className="text-center py-2 small text-muted border-top">
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden
                            />
                            Loading…
                          </div>
                        )}
                      </div>
                      <div
                        className="border-top w-100 d-flex justify-content-center align-items-center"
                        style={{
                          minHeight: 40,
                          background: "#fff",
                          position: "sticky",
                          bottom: 0,
                        }}
                      >
                        <span
                          className="fw-semibold text-secondary"
                          style={{
                            cursor: "pointer",
                            fontSize: 12,
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={async () => {
                            await markAllMessagesAsRead();
                            navigate("/whatsapp_messenger", {
                              state: {
                                fromNotification: true,
                                markedAllAsRead: true,
                              },
                            });
                            setShowNotif(false);
                          }}
                        >
                          <i
                            className="fa fa-envelope me-2"
                            style={{ fontSize: 14 }}
                          />
                          Read All Messages
                        </span>
                      </div>
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </div>

              {whatsappSetting.length > 0 &&
                userInfo.userrole != "SYS_ADMIN" &&
                (() => {
                  const activeSetting = whatsappSetting.find(
                    (s) => String(s.phone) === String(selectedSetting),
                  );
                  const quality = activeSetting?.quality?.toLowerCase();
                  const selectTitle = activeSetting
                    ? `${activeSetting.name} ${activeSetting.phone}`
                    : selectedSetting;
                  return (
                    <Form.Select
                      value={selectedSetting}
                      onChange={handleSettingChange}
                      aria-label="Select WhatsApp Setting"
                      className="header-whatsapp-select"
                      title={selectTitle}
                    >
                      {whatsappSetting.map((setting, index) => (
                        <option
                          key={`${setting.phone}-${setting.id || index}`}
                          value={setting.phone}
                        >
                          {setting.phone} · {setting.name}
                        </option>
                      ))}
                    </Form.Select>
                  );
                })()}

              {sessionStorage.getItem("token") ? (
                <Button
                  variant="outline-primary"
                  onClick={logout}
                  title="Logout"
                  id="logout-btn"
                  className="header-logout-btn flex-shrink-0"
                >
                  <i className="fa-solid fa-right-from-bracket" />
                </Button>
              ) : (
                <></>
              )}
            </div>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Full-width quality strip under the main nav */}
      {qualityBannerEl && (
        <div className="header-quality-strip w-100">{qualityBannerEl}</div>
      )}
    </>
  );
};
export default Header;
